import { render, staticRenderFns } from "./CreateSchoolOrder.vue?vue&type=template&id=7df25cc7&"
import script from "./CreateSchoolOrder.vue?vue&type=script&lang=js&"
export * from "./CreateSchoolOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports